const ReactRedux = require('react-redux');

const actions = require('../../_actions.js');
const Button = require('../../components/Button.jsx');
const constants = require('../../constants/deployment.js');

const mapStateToProps = function(state) {
	return {
		display: constants.canBypass(state),
		disabled: state.approval.is_loading,
		style: "btn btn-warning",
		value: "Bypass approval",
		icon: "fa fa-level-down"
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onClick: function() {
			dispatch(actions.approveDeployment());
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Button);
